<template>
  <b-button
    @click="onClick"
    :type="buttonType"
    :disabled="isDisabled"
    :loading="loading"
  >
    Save
  </b-button>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import ui from "@/store/modules/ui";
import annotations from "@/store/modules/annotations";

export default {
  setup() {
    // save image
    const loading = ref(false);

    const onClick = async () => {
      loading.value = true;
      try {
        await annotations.postAnnotations(annotations);
        ui.setHasUnsavedChange(false);
      } catch (error) {
        // save failed
        console.error(
          "onClick in SaveButton failed at postAnnotations: " + error
        );
        Snackbar.open({
          message: error.message,
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      } finally {
        // end loading
        loading.value = false;
      }
    };

    // switch button type based on unsaved changes
    const hasUnsavedChange = computed(() => ui.hasUnsavedChange);
    const buttonType = computed(() => {
      if (hasUnsavedChange.value) {
        return "is-warning";
      } else {
        return "";
      }
    });

    // disable button based on annotationState
    const annotationState = computed(() => annotations.state);
    const isDisabled = computed(() => {
      return annotationState.value === "finished" ||
        annotationState.value === "empty"
        ? true
        : false;
    });

    return {
      loading,
      onClick,
      buttonType,
      isDisabled,
      hasUnsavedChange
    };
  }
};
</script>
